import React, { useMemo } from 'react';
import styled from 'styled-components';
import { Container, Row, Col } from 'react-bootstrap';
import { NavListItem } from '../../../pages/categoryCause/charityData';
import { CategoryListItem } from '../../../utils/types';
import { useDispatch } from 'react-redux';
import { nonprofitsHandler } from '../../../redux/slices/donationCamp/nonprofit-slice';
import { useNavigate } from 'react-router-dom';

// Styled component for the links
const CharityLink = styled.a`
   color: #333;
    font-size: 14px;
    font-family: 'Jost', sans-serif;
    font-weight: 500;
    line-height: 22px;
     text-decoration: none;
    cursor: pointer;
`;
const MajorCity = styled.div`
 background:#fff;
     padding: 20px;
    margin-top: 22px;
    margin-bottom: 22px;
    border-radius: 20px;
  
`;

// A function to chunk the charity list into groups of 3
const chunkArray = (arr: any[], size: number) => {
  const chunks = [];
  for (let i = 0; i < arr?.length; i += size) {
    chunks.push(arr.slice(i, i + size));
  }
  return chunks;
};

type CharityListProps = {
  charities: Array<NavListItem | CategoryListItem>
}
const CharityList = ({ charities }: CharityListProps) => {
  // Divide the charities into rows of 3
  const dispatch: any = useDispatch()
  const navigate: any = useNavigate()
  const handleStateClick = (stateName: string, stateHref: string) => {
    dispatch(
      nonprofitsHandler({
        all: false,
        search: "",
        country: "",
        state: stateName,
        city: "",
        zipcode: "",
        category: "",
        sort_by: "",
        page: 1,
        size: 9,
      })
    );

    navigate(stateHref); // Navigate to the selected state page
  };

  const charityRows = useMemo(() => chunkArray(charities, 3), [charities]);



  return (

    <MajorCity>
      {charityRows.map((row, rowIndex) => (
        <Row key={rowIndex} className="mb-3">
          {row.map((charity: any, colIndex: number) => (
            <Col key={colIndex + 1} md={4}>
              <CharityLink href='' onClick={(e: any) => { e.preventDefault(); handleStateClick(charity?.key, charity?.href) }}>{charity?.name || charity?.title}</CharityLink>
            </Col>
          ))}
        </Row>
      ))}
    </MajorCity>

  );
};

export default CharityList;